import { ChoiceField } from './ChoiceField';
import type { FormFieldComponent } from './types';

/** No `formSchema`: see `ChoiceField` for why an unfillable field must not be required. */
const GenericFormRadioGroup: FormFieldComponent = () => <ChoiceField family="formFields" role="radioGroupFormField" />;

export default GenericFormRadioGroup;
